var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.313,
    height: 22.5,
    viewBox: "0 0 25.313 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exclamation-triangle",
    "data-name": "Icon awesome-exclamation-triangle",
    d: "M25.028,19.337A2.111,2.111,0,0,1,23.2,22.5H2.112A2.111,2.111,0,0,1,.285,19.337L10.829,1.054a2.111,2.111,0,0,1,3.654,0Zm-12.371-3.78a2.021,2.021,0,1,0,2.021,2.021A2.021,2.021,0,0,0,12.656,15.557ZM10.737,8.29l.326,5.977a.527.527,0,0,0,.527.5h2.133a.527.527,0,0,0,.527-.5l.326-5.977a.527.527,0,0,0-.527-.556H11.264a.527.527,0,0,0-.527.556Z",
    fill: "#f93d5c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.77bcf68d53f1a05420be7ce41e650b47.svg";
export { ForwardRef as ReactComponent };